import { Reveal } from "./Reveal";
import { NewsletterForm } from "./NewsletterForm";

export const NewsletterSection = () => (
  <section
    id="newsletter"
    data-testid="newsletter-section"
    className="bg-cream px-6 py-24 sm:px-10 sm:py-28 lg:px-16"
  >
    <Reveal className="mx-auto max-w-xl">
      <div className="rounded-[2rem] border border-sand bg-white p-8 shadow-xl shadow-brick/5 sm:p-12">
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-brick">
          Darmowa konsultacja
        </span>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">
          Odbierz darmową konsultację
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-clay sm:text-base">
          Zostaw e-mail — odezwę się z darmową konsultacją i informacjami o
          nowościach dla Twojego lokalu.
        </p>
        <div className="mt-8">
          <NewsletterForm idPrefix="newsletter" />
        </div>
      </div>
    </Reveal>
  </section>
);
